import {Button} from '@primer/react'
import {Link} from '@github-ui/react-core/link'

export type ActionConfig = {linkTo: string; label: string} | {onClick: () => void; label: string}

export function Action({action}: {action: ActionConfig}) {
  if ('linkTo' in action) {
    return (
      <Button as={Link} to={action.linkTo} variant="invisible" size="small">
        {action.label}
      </Button>
    )
  }

  return (
    <Button type="button" variant="invisible" size="small" onClick={action.onClick}>
      {action.label}
    </Button>
  )
}
